import httpClient from '@/lib/httpClient'
import useAuthStore from '@/store/useAuthStore'
import { handleFormError } from '@/utils/helpers'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

export default function useSwitchTeam({
  setError = null,
  clientServerFieldMapping = null,
} = {}) {
  const setCurrentTeamId = useAuthStore((state) => state.setCurrentTeamId)
  const queryClient = useQueryClient()

  const action = async ({ teamId }: { teamId: number }) => {
    const response = await httpClient.post('team/team/switch', {
      team_id: teamId,
    })
    return response
  }

  const mutation = useMutation({
    mutationFn: action,
    onSuccess: (res, variables) => {
      setCurrentTeamId(variables.teamId)
      toast.success('Space switched')
      // Invalidate every query in the cache
      queryClient.invalidateQueries()
    },
    onError: (error, variables) =>
      handleFormError({
        error,
        variables,
        setError,
        clientServerFieldMapping,
      }),
  })

  return {
    action: mutation.mutateAsync,
    status: mutation,
  }
}
